import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Tab extends Component {
    static propTypes = {
        activeTab: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    onClick = () => {
        const { label, onClick } = this.props;
        onClick(label);
    }

    render() {
        const {
            onClick,
            props: {
                activeTab,
                label,
            },
        } = this;

        let className = 'btn btn-light mr-2 mb-2 text-left';

        if (activeTab === label) {
            className = 'btn btn-primary mr-2 mb-2 text-left';
        }

        return (

            <a
                className={className}
                onClick={onClick}
            >
               {label}
            </a>
        );
    }
}


export default Tab;
